import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { CardMetricSkeleton } from "../../components/loader";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import 'react-toastify/dist/ReactToastify.css';
import { aiService } from "../../service/api.service";

const SUBSCRIPTION_TYPES = ["Trial", "Standard", "Premium", "Enterprise"];

export const Home = () => {
  const [loader, setLoader] = useState(false);
  const [dashbordData, setDashbordData] = useState([]);
  const [assignedNumbersCount, setAssignedNumbersCount] = useState(null);
  const [enabledAgentsCount, setEnabledAgentsCount] = useState(null);
  const [disabledAgentsCount, setDisabledAgentsCount] = useState(null);
  const [activeUsersCount, setActiveUsersCount] = useState(null);
  const [deactivatedUsersCount, setDeactivatedUsersCount] = useState(null);
  const [subscriptionCounts, setSubscriptionCounts] = useState({});
  const [expiredSubscriptionsCount, setExpiredSubscriptionsCount] = useState(null);

  useEffect(() => {
    dashboardList()
  }, [])

  async function dashboardList() {
    setLoader(true)
    try {
      const response = await aiService.dashboard();
      if (response?.status === 200) {
        const summary = response?.data || {};
        setDashbordData(summary);
        setAssignedNumbersCount(summary.assigned_numbers_count ?? null);
        setEnabledAgentsCount(summary.enabled_agents_count ?? null);
        setDisabledAgentsCount(summary.disabled_agents_count ?? null);
        setActiveUsersCount(summary.active_users_count ?? null);
        setDeactivatedUsersCount(summary.deactivated_users_count ?? null);
        setSubscriptionCounts(summary.subscription_counts || {});
        setExpiredSubscriptionsCount(summary.expired_subscriptions_count ?? null);
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        swal({ icon: 'error', text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear()
          window.location.href = "/";
        });
      } else {
        swal({ icon: 'error', text: error?.response?.data?.message ? error?.response?.data?.message : error?.message, button: "OK" }).then(() => {
          console.log('OK button clicked after error alert');
        });
      }
    } finally {
      setLoader(false)
    }
  }

  const renderMetric = (value) => value ?? "-";

  return (
    <>
      <div className="dashboard-main-area company-list-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <div className="under-content-section">
              <div>
                <h1 className="company-page-title">Dashboard</h1>
                <h5 className="company-page-subtitle">Overview of companies, users, agents, and assigned numbers</h5>
              </div>
            </div>
          </div>
          <div className="dashboard-area">
            <Row className="justify-content-center">
              <Col md={12}>
                <Row>
                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list" className="dashboardlink">
                      <div className="dashboard-cards tone-success">
                        <div className="card-top">
                          <span className="card-label">Total Created Company</span>
                          <span className="card-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                            </svg>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(dashbordData?.customers_count)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?status=active" className="dashboardlink">
                      <div className="dashboard-cards tone-info">
                        <div className="card-top">
                          <span className="card-label">Active Company</span>
                          <span className="card-icon">
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(activeUsersCount)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?status=inactive" className="dashboardlink">
                      <div className="dashboard-cards tone-teal">
                        <div className="card-top">
                          <span className="card-label">Deactivated Company</span>
                          <span className="card-icon">
                            <i className="fa fa-user-times" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(deactivatedUsersCount)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/allagentlist" className="dashboardlink">
                      <div className="dashboard-cards tone-warning">
                        <div className="card-top">
                          <span className="card-label">Total Agents</span>
                          <span className="card-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.7 24.7 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.187-.135"/>
                              <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5"/>
                            </svg>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(dashbordData?.agents_count)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/allagentlist?status=enabled" className="dashboardlink">
                      <div className="dashboard-cards tone-success">
                        <div className="card-top">
                          <span className="card-label">Enabled Agents</span>
                          <span className="card-icon">
                            <i className="fa fa-check-circle" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(enabledAgentsCount)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/allagentlist?status=disabled" className="dashboardlink">
                      <div className="dashboard-cards tone-danger">
                        <div className="card-top">
                          <span className="card-label">Disabled Agents</span>
                          <span className="card-icon">
                            <i className="fa fa-ban" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(disabledAgentsCount)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/assign-numbers?status=Assigned" className="dashboardlink">
                      <div className="dashboard-cards tone-teal">
                        <div className="card-top">
                          <span className="card-label">Assigned Numbers</span>
                          <span className="card-icon">
                            <i className="fa fa-phone" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(assignedNumbersCount)}
                        </div>
                      </div>
                    </Link>
                  </Col>
                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?subscription=Trial" className="dashboardlink">
                      <div className="dashboard-cards tone-info">
                        <div className="card-top">
                          <span className="card-label">Trial Subscriptions</span>
                          <span className="card-icon">
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(subscriptionCounts.Trial)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?subscription=Standard" className="dashboardlink">
                      <div className="dashboard-cards tone-success">
                        <div className="card-top">
                          <span className="card-label">Standard Subscriptions</span>
                          <span className="card-icon">
                            <i className="fa fa-star-o" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(subscriptionCounts.Standard)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?subscription=Premium" className="dashboardlink">
                      <div className="dashboard-cards tone-warning">
                        <div className="card-top">
                          <span className="card-label">Premium Subscriptions</span>
                          <span className="card-icon">
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(subscriptionCounts.Premium)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?subscription=Enterprise" className="dashboardlink">
                      <div className="dashboard-cards tone-teal">
                        <div className="card-top">
                          <span className="card-label">Enterprise Subscriptions</span>
                          <span className="card-icon">
                            <i className="fa fa-building" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(subscriptionCounts.Enterprise)}
                        </div>
                      </div>
                    </Link>
                  </Col>

                  <Col className="mb-3 dashboard-card-col">
                    <Link to="/company-list?subscriptionStatus=Expired" className="dashboardlink">
                      <div className="dashboard-cards tone-danger">
                        <div className="card-top">
                          <span className="card-label">Expired Subscriptions</span>
                          <span className="card-icon">
                            <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div className="card-value">
                          {loader ? <CardMetricSkeleton /> : renderMetric(expiredSubscriptionsCount)}
                        </div>
                      </div>
                    </Link>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
